import { Component, Input, OnInit } from '@angular/core';
import { IChecklist } from '@signal/asp-data-commons';

@Component({
  selector: 'app-checklist-item',
  templateUrl: './checklist-item.component.html',
  styleUrls: ['./checklist-item.component.scss']
})
export class ChecklistItemComponent implements OnInit {

  @Input() item: IChecklist;

  constructor() { }

  ngOnInit(): void {
  }

}
